import { render, staticRenderFns } from "./fleg-comp-salario-diario-base-de-cotizacion-para-efectos-del-imss-e-infonavit.vue?vue&type=template&id=8ad253ca&lang=html&"
import script from "./fleg-comp-salario-diario-base-de-cotizacion-para-efectos-del-imss-e-infonavit.vue?vue&type=script&lang=js&"
export * from "./fleg-comp-salario-diario-base-de-cotizacion-para-efectos-del-imss-e-infonavit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports